// @core/api/endpoints/billing/create_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateInvoiceRequest,
  CreateInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create invoice
 * Creates a new invoice in draft status. Draft invoices can be edited before finalization. Optionally auto-finalize upon creation.
 */
export async function CreateInvoice(
  data: CreateInvoiceRequest,
  options?: RequestOptions
): Promise<CreateInvoiceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invoices`;
  const requestOptions = options;
  return client.post<CreateInvoiceResponse>(requestPath, data, requestOptions);
}
